import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface LegendaItem {
	class: string;
	description: string;
}

interface ParsedOrder {
	field: string;
	label: string;
	direction: 'asc' | 'desc';
	icon: string;
}

// Computed per parsare il testo di ordinamento e renderlo più intuitivo

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultsHeaderLayout',
  props: {
    orderingBy: null,
    legend: null
  },
  setup(__props: any) {

const props = __props as {
	orderingBy?: string;
	legend?: LegendaItem[];
};



// Interfaccia per un singolo ordinamento
const parsedOrders = computed((): ParsedOrder[] => {
	if (!props.orderingBy || props.orderingBy.trim() === '') {
		return [];
	}

	// Parse del formato: "Cliente (desc), Commessa (asc), Data Fine (desc)"
	const orders: ParsedOrder[] = [];
	const parts = props.orderingBy.split(', ');

	for (const part of parts) {
		// Regex per catturare "Nome Campo (direzione)"
		const match = part.match(/^(.+?)\s*\((asc|desc)\)$/);
		if (match) {
			const label = match[1].trim();
			const direction = match[2] as 'asc' | 'desc';

			orders.push({
				field: label.toLowerCase().replace(/\s+/g, '_'),
				label,
				direction,
				icon: direction === 'asc' ? 'el-icon-sort-up' : 'el-icon-sort-down',
			});
		}
	}

	return orders;
});

return { __sfc: true,props, parsedOrders }
}

})